import { render } from "./FeedbackGenerationModal.vue?vue&type=template&id=0c4fe894&scoped=true"
import script from "./FeedbackGenerationModal.vue?vue&type=script&lang=js"
export * from "./FeedbackGenerationModal.vue?vue&type=script&lang=js"

import "./FeedbackGenerationModal.vue?vue&type=style&index=0&id=0c4fe894&scoped=true&lang=css"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4fe894"]])

export default __exports__